import React from 'react';
import { FOOTER_LINKS, SOCIAL_LINKS } from '../constants/navigation';
import ContactLink from './ContactLink';
import '../styles/utilities.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            {FOOTER_LINKS.quick.map((link) => (
              <li key={link.path}>
                <a href={link.path}>{link.label}</a>
              </li>
            ))}
          </ul>
        </div>

        <div className="footer-section">
          <h4>Contact Info</h4>
          <p>
            Phone:{' '}
            <ContactLink type="phone" className="link-gold" />
          </p>
          <p>
            Email:{' '}
            <ContactLink type="email" className="link-gold" />
          </p>

          <div className="social-links">
            <h4>Follow Us</h4>
            <div className="social-icons">
              {SOCIAL_LINKS.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.name}
                >
                  {social.isImage ? (
                    <img src={social.icon} alt={social.name} className="social-icon-img" />
                  ) : (
                    social.icon
                  )}
                </a>
              ))}
            </div>
          </div>
        </div>

      </div>

      <div className="footer-bottom">
        <p>&copy; 2026 Travel Mhor. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;